// Xpnsr SEO — English translations.
// Extracted from the former monolithic frontend/src/i18n.js (1731 lines)
// flagged by the audit report. Pure data; consumed via the
// `translations.en` re-export in `./index.js`.

export default {
  // Sidebar
  nav: {
    dashboard: "Dashboard",
    sites: "Projects",
    pbn: "PBN Network",
    audit: "SEO Audit",
    articles: "Article Generator",
    promotion: "Promotion",
    automation: "Automation",
    keywords: "Keywords",
    ranks: "Rankings",
    reports: "Reports",
    settings: "API keys",
    admin: "Admin",
    tip: "→ tip",
    tipText: "Add a site, then run an SEO audit",
    signOut: "sign out",
    product: "// product",
    navigate: "// navigate",
    dmGroup: "// domains",
    dmDomains: "Domains",
    dmPublisher: "PBN Publisher",
    dmSettings: "Domain settings",
    bookDemo: "Book Demo",
  },

  // Topbar
  top: {
    live: "live",
    offline: "offline",
    checking: "checking",
    searchPlaceholder: "Search sites, keywords, audits…",
  },

  // Login
  login: {
    heading: "Sign in",
    sub: "// SEO TRACKER — RESTRICTED ACCESS",
    email: "EMAIL",
    password: "PASSWORD",
    emailHolder: "you@xpnsr.tech",
    passHolder: "••••••••••",
    submit: "ACCESS DASHBOARD",
    submitting: "CONNECTING...",
    registerSubmit: "CREATE ACCOUNT",
    registerSubmitting: "CREATING...",
    switchToRegister: "No account? Register",
    switchToLogin: "Have an account? Sign in",
    forgotPassword: "Forgot password?",
    forgotPasswordHelp: "Email support@xpnsr.tech and we’ll reset it manually.",
    registerHeading: "Create account",
    registerSub: "// FREE WHILE IN BETA",
    passwordMinHint: "min 8 characters",
    encrypted: "session encrypted · TLS 1.3",
    emailError: "Enter a valid email",
    passError: "Password is required",
    connectError: "Connection error",
    tabSignIn: "Sign in",
    tabRegister: "Create account",
    heroBack: "back",
    heroPrefix: "Welcome",
    heroPrefixRegister: "Create your",
    heroAccent: "account",
    heroSub: "// CBN · rank · backlinks · content network",
    statusSession: "session",
    statusSessionVal: "encrypted · TLS 1.3",
    statusDataforseo: "dataforseo",
    statusDataforseoVal: "api · connected",
    statusDeepseek: "deepseek",
    statusDeepseekVal: "cluster · ready",
  },

  // Dashboard
  dashboard: {
    title: "Dashboard",
    subtitle: "Overview of your SEO performance",
    noSites: "No sites added yet",
    noSitesDesc: "Add your first site to start tracking",
    addSite: "Add Site",
    totalSites: "Total Sites",
    keywords: "Keywords Tracked",
    articles: "Articles Generated",
    avgPosition: "Avg. Position",
    avgScore: "Avg. Score",
    audits: "Total Audits",
    yourSites: "Your Sites",
    allSites: "All Sites →",
    recentAudits: "Recent Audits",
    quickActions: "Quick Actions",
    runAudit: "Run Audit",
    aiContent: "AI Content",
    notChecked: "Not checked",
    noAudits: "No audits",
    runFirstAudit: "Run first audit",
    score: "Score",
    issues: "issues",
  },

  // Sites
  sites: {
    title: "Projects",
    subtitle: "Sites you promote through the PBN network",
    add: "Add project",
    name: "Project name",
    url: "URL",
    provider: "Provider",
    providerConfig: "Provider Config",
    registrar: "Registrar",
    ipAddress: "IP address",
    nsServers: "NS servers",
    deployedAt: "Last deploy",
    deploy: "Deploy",
    redeploy: "Redeploy",
    createProject: "Create project",
    saveProvider: "Save provider",
    providerBadge: "Provider",
    chooseProvider: "Choose provider",
    cloudflarePages: "Cloudflare Pages",
    vercel: "Vercel",
    netlify: "Netlify",
    githubPages: "GitHub Pages",
    phpHost: "PHP Host",
    external: "External (not deployed by this platform)",
    cfWorker: "Cloudflare Worker (already deployed)",
    optional: "optional",
    providerConfigHint:
      "Only needed for providers this platform deploys itself (PHP Host, Cloudflare Pages, etc). Leave empty for External or Cloudflare Worker.",
    namePlaceholder: "My Blog",
    urlPlaceholder: "https://example.com",
    providerConfigPlaceholder:
      '{"project_name":"my-site","account_id":"..."}',
    registrarPlaceholder: "namecheap",
    serpLocation: "SERP location",
    serpLocationPlaceholder: "Russia (default)",
    serpLanguage: "SERP language",
    serpLanguagePlaceholder: "Russian (default)",
    serpLocaleHint:
      "DataForSEO location_name / language_name used when checking rankings. Leave blank to use the platform default (Russia / Russian).",
    serpLocale: "SERP locale",
    serpDefaultLabel: "Default",
    editSerpLocale: "Edit SERP locale",
    serpLocaleSaved: "SERP locale updated",
    serpLocaleSaveFailed: "Failed to update SERP locale",
    save: "Add Site",
    cancel: "Cancel",
    delete: "Delete",
    noSites: "No sites yet",
    noSitesDesc: "Add your first website to start tracking",
    audit: "Audit",
    keywords: "keywords",
    articles: "articles",
    lastAudit: "Last audit",
    score: "Score",
    added: "Added",
    siteAdded: "Project added",
    siteDeleted: "Site deleted",
    auditComplete: "Audit complete",
    loadError: "Error loading sites",
    deleteError: "Error deleting site",
    deleteTitle: "Delete site?",
    deleteDesc:
      "This action cannot be undone. All audit data and keywords will be deleted.",
    notChecked: "Not checked",
    noProviderData: "No provider data",
    deploymentQueued: "Deployment queued",
    deploymentDone: "Deployment complete",
    deploymentFailed: "Deployment failed",
    errors: {
      invalidUrl: "Please enter a valid URL",
      addFailed: "Failed to add site",
      deleteFailed: "Failed to delete site",
      invalidProviderConfig: "Provider config must be valid JSON",
    },
  },

  // Keywords
  keywords: {
    title: "Keywords",
    subtitle: "Track positions for important queries",
    add: "Add Keyword",
    keyword: "Keyword",
    placeholder: "e.g. best laptops 2026",
    position: "Position",
    added: "Added",
    actions: "Actions",
    noKeywords: "No keywords yet",
    noKeywordsDesc: "Add keywords to start tracking rankings",
    checkAll: "Check All",
    check: "Check",
    checking: "Checking...",
    delete: "Delete",
    added: "Keyword added",
    deleted: "Keyword deleted",
    posFound: (pos) => `Position: ${pos} (DataForSEO)`,
    notInTop100: "Site not found in top-100 for this keyword",
    loadError: "Error loading keywords",
    errors: {
      empty: "Enter a keyword",
      duplicate: "This keyword already exists",
      addFailed: "Failed to add keyword",
      deleteFailed: "Failed to delete keyword",
      checkFailed: "Error checking position",
    },
  },

  // Ranks
  ranks: {
    title: "Rankings",
    subtitle: "Monitor keyword positions",
    noSites: "No sites",
    noKeywords: "No keywords",
    noSitesDesc: "Add a site first",
    noKeywordsDesc: "Add keywords on the Keywords page",
    checkNow: "Check positions",
    checking: "Checking...",
    lastCheck: "✓ Last DataForSEO check",
    lastCheckedSummary: (count, engine, time) =>
      `Last check: ${count} keywords · ${engine} · ${time}`,
    dataSource:
      "Positions are pulled from Google/Yandex via DataForSEO — real data, no simulation.",
    dataSourceHint:
      "You need a DataForSEO login and password for this to work.",
    goToSettings: "Open Settings → API keys",
    currentPosition: "Current position",
    keywords: "Keywords",
    history: "History",
    current: "Current",
    best: "Best",
    checks: "Checks",
    noData: "No position data",
    noDataDesc: 'Click "Check positions" — data is pulled live from DataForSEO',
    currentPos: "Current position",
    position: "Position",
    dfsChecked: (n) => `Checked ${n} keywords`,
    dfsNotConfig:
      "DataForSEO login/password not set — fill them in Settings → API keys",
    dfsUnauthorized:
      "DataForSEO rejected the login/password. Re-check them in Settings → API keys",
    dfsError: "DataForSEO error",
    unknownError: "Unknown error",
    offTop100Summary: (n) =>
      `${n} off top-100`,
    offTop100Tooltip:
      "Checks that didn't find the site in the top 100 — omitted from the chart so they don't create misleading spikes on the trend.",
  },

  // Article Generator
  articles: {
    title: "Article Generator",
    subtitle: "Generate SEO-optimized articles",
    noSites: "No sites",
    noSitesDesc: "Add a site first",
    generator: "Generator",
    single: "Single",
    bulk: "Bulk",
    site: "Site",
    keyword: "Keyword",
    keywordHolder: "e.g. how to choose a laptop",
    language: "Language",
    generate: "Generate Article",
    generating: "Generating (~30s)...",
    bulkKeywords: "Keywords (one per line)",
    bulkHolder: "how to choose a laptop\nbest laptops 2026\nlaptop for work",
    bulkMax: "Maximum 10 articles at once",
    generateAll: "Generate All",
    generatingAll: "Generating...",
    list: "Generated Articles",
    noArticles: "No articles yet",
    words: "words",
    published: "✓ Published",
    preview: "Preview",
    viewRendered: "Preview",
    viewSource: "HTML",
    title_: "Title:",
    meta: "Meta Description:",
    content: "Content:",
    copyHTML: "Copy HTML",
    republish: "Republish",
    webhook: "Webhook",
    toPBN: "To PBN",
    assignTitle: "Send to PBN Campaign",
    article_: "Article:",
    campaign: "Campaign",
    satellite: "Satellite",
    selectCamp: "Select campaign...",
    selectSat: "Select satellite...",
    noSatellites: "No satellites with webhook in this campaign",
    send: "Send to PBN",
    sending: "Sending...",
    close: "Cancel",
    published_: "Published",
    downloaded: (filename) => `Downloaded: ${filename}`,
    publishedWebhook: "Published via webhook",
    webhookNotConfig:
      "Webhook not configured — go to Automation and enter the URL",
    errors: {
      noKeyword: "Enter a keyword",
      noKeywords: "Enter keywords",
      tooMany: (k) =>
        `Max 10 keywords, you have ${k} — extras will be ignored`,
      none: "Failed to generate any articles",
      timeout:
        "Generation took too long — refresh the page, articles may already be ready",
      loadFailed: "Loading error",
    },
  },

  // PBN
  pbn: {
    title: "PBN Network",
    subtitle: "Manage satellites and promote your target sites",
    overview: "Overview",
    satellites: "Satellites",
    campaigns: "Campaigns",
    articles_: "Articles",
    stats: {
      satellites: "Satellites",
      campaigns: "Campaigns",
      articles: "Articles",
      published: "Published",
    },
    sat: {
      title: "Satellite Domains",
      subtitle: "Add domains in bulk to build your network",
      add: "Add Domains",
      domainsLabel: "Domains (one per line)",
      domainsHolder: "example.com\nmysite.net\nblog.io",
      webhookLabel: "Webhook URL (optional, apply to all)",
      webhookHolder: "https://domain.com/publish.php",
      providerLabel: "Provider",
      providerHolder: "cloudflare_pages",
      ipAddress: "IP address",
      registrar: "Registrar",
      nsServers: "NS servers",
      deployedAt: "Last deploy",
      diversityScore: "Diversity score",
      count: (d) => `${d} domains`,
      addBtn: "Add Satellites",
      adding: "Adding...",
      noSats: "No satellites yet",
      noSatsDesc: "Add satellite domains to build your PBN",
      articles: "articles",
      noWebhook: "No webhook",
      webhook: "Webhook URL",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      confirmDelete: "Delete this satellite?",
      deselectAll: "Deselect all",
      selectAll: "Select all",
      whiteRefresh: "Reinstall white page",
      whiteInstall: "Install white page",
      toasts: {
        enterDomains: "Enter at least one domain",
        added: (n) => `Added ${n} domain(s)`,
        addError: "Could not add domains",
        deleted: "Deleted",
        deleteError: "Delete failed",
        whiteStarted: (name) => `White-page generation started for ${name}`,
        whiteReady: (name) => `White page for ${name} ready!`,
        whiteError: (msg) => `Error: ${msg}`,
        whiteGenericError: "Generation error",
        pickSats: "Pick at least one satellite",
        bulkStarted: (n) => `Bulk generation started for ${n} satellites`,
        bulkSkipped: (n) => `${n} satellite(s) skipped (no worker URL configured or not found)`,
        bulkDone: (ok, fail) => `Done: ${ok} succeeded, ${fail} failed`,
        bulkGenericError: "Error",
      },
    },
    camp: {
      title: "Campaigns",
      subtitle: "Link target sites with satellites and generate articles",
      new: "New Campaign",
      name: "Campaign Name",
      namePlaceholder: "Promote mysite.com",
      targetSite: "Target Site (to promote)",
      selectSite: "Select site",
      keywords: "Keywords (one per line)",
      keywordsHolder: "buy laptop\nbest laptops 2025\nlaptop for work",
      anchors: "Anchor texts (one per line)",
      anchorsHolder:
        "Acme\nAcme platform\nbest project tracker\nthe Acme dashboard",
      anchorsHelp:
        "Required. Mix branded (your site name), topical (target keywords), and descriptive phrases. Avoid generic anchors like 'learn more' / 'read more' — they create a cross-tenant footprint that backlink audits flag as toxic.",
      anchorsRequired: "Add anchor texts (at least one)",
      satellitesRequired: "Select at least one satellite",
      autofillBtn: "Auto-generate keywords + anchors",
      autofillHint:
        "Pick a target site and select your satellites, then let AI fill the keyword and anchor pools below. The pool size scales to the number of satellites. Review and edit before creating.",
      autofillBtnMore: "AI-generate more keywords + anchors",
      autofillHintEdit:
        "Adds newly generated keywords and anchors to the lists below instead of replacing them - review before saving.",
      autofillNeedsSite: "Select a target site first",
      autofillNeedsSats:
        "Select satellites first — the pool size scales to the number of satellites",
      autofillProjection: "≈ {k} keywords / {a} anchors for {s} satellites",
      autofillBusy: "Generating keywords & anchors…",
      autofillDone: "Generated {k} keywords and {a} anchors",
      autofillError: "Auto-generate failed",
      targetUrls: "Target URLs (one per line, optional)",
      targetUrlsHolder:
        "https://example.com/\nhttps://example.com/features\nhttps://example.com/pricing",
      targetUrlsHelp:
        "Optional. Backlinks are distributed across this URL pool — repeat a URL on its own line to give it more weight. Leave empty to fall back to the target site's homepage (creates a strong PBN footprint).",
      satellites: "Satellites for this campaign",
      noSats: "Add satellite domains first",
      selected: (n) => `Selected: ${n}`,
      perSat: "Articles per satellite",
      language: "Article language",
      create: "Create Campaign",
      creating: "Creating...",
      noCamps: "No campaigns",
      noCampsDesc:
        "Create a campaign to link your target site with satellites",
      generate: "Generate",
      publish: "Publish All",
      delete: "Delete",
      confirmDelete: "Delete this campaign and all its articles?",
      deleteTitle: "Delete campaign?",
      deleteIntro: "“{name}” will be removed.",
      deleteArticlesNote: "It has {n} linked article(s).",
      deleteAlsoArticles: "Also delete unpublished drafts ({n} linked)",
      deleteAlsoArticlesHelp:
        "Off (default): all articles are detached and stay in the Articles tab. On: only never-published drafts are removed — already-published articles are always preserved so their live backlinks keep working.",
      deleteCancel: "Cancel",
      deleteConfirmKeep: "Delete campaign, keep articles",
      deleteConfirmAll: "Delete campaign + drafts",
      deletedKeptToast: "Campaign deleted, {n} article(s) kept",
      deletedAllToast: "Campaign deleted ({removed} draft(s) removed, {kept} published kept)",
      unlock: "Release stuck lock",
      unlocked: "Locks released",
      recount: "Resync counters",
      recounted: "Counters synced",
      generating: "Generating\u2026",
      publishing: "Publishing\u2026",
      settings: "Settings",
      settingsTitle: (n) => `Campaign Settings: ${n}`,
      status: "Status",
      statusActive: "Active",
      statusPaused: "Paused",
      statusDone: "Completed",
      saveChanges: "Save Changes",
      cancel: "Cancel",
      satsLabel: "Satellites",
      satCount: (n) => `Selected: ${n}`,
      keywordsLabel: "keywords",
      articlesLabel: "articles",
      publLabel: "publ.",
      viewArticles: "Articles",
      viewArticlesTitle: "Open the Articles tab pre-filtered by this campaign",
      liveCountersTooltip: "Live counters — refreshed automatically every 15 s",
      cadenceLabel: "Publish cadence (articles / day)",
      cadenceOff: "Off (unlimited)",
      cadenceDay: "day",
      cadenceCustom: "Custom\u2026",
      cadenceCustomAria: "Custom articles per day (1\u2013500)",
      cadenceHelp:
        "Pick a preset or set a custom value (1\u2013500). The scheduler auto-publishes up to N draft articles per UTC day. Off = publish-bulk fires everything at once.",
    },
    art: {
      title: (n) => `PBN Articles (${n})`,
      recentArticles: "Recent Articles",
      selectToView: "Select an article to view",
      titleLabel: "Title:",
      metaLabel: "Meta:",
      backlinksLabel: "Backlinks:",
      contentLabel: "Content:",
      refresh: "Refresh",
      campaign: "Campaign",
      allCamps: "All Campaigns",
      status: "Status",
      allStatuses: "All Statuses",
      published_: "Published",
      draft: "Draft",
      failed: "Failed",
      noArticles: "No articles yet",
      noArticlesDesc: "Generate articles in a campaign first",
      publish: "Publish",
      publishing: "Publishing...",
      copy: "Copy",
      preview: "Preview",
      delete: "Delete",
      confirmDelete: "Delete this article?",
      keyword: "Keyword:",
      site: "Site:",
      satellite: "Satellite:",
      words: "words",
      backlinks: "backlinks",
      detachedFrom: "detached: {name}",
      detachedFromTitle:
        "Original campaign “{name}” was deleted. The article was kept so the satellite’s published link stays alive.",
      contentPreview: "Content preview:",
    },
    // Tier-2/3 admin actions (Replay CF KV, Cleanup audit, Sync platforms,
    // and the per-campaign tier-2/3 launch buttons). Strings used to be
    // hardcoded Russian literals inside CampaignsTab.jsx / CampaignCard.jsx
    // / SyncPlatformsPanel.jsx; consolidated here per audit item 1.4.7.
    tier23: {
      phase: {
        tier2: "Tier-2 only",
        tier3: "Tier-3 only",
        both: "Tier-2/3",
      },
      starting: (label) => `Starting ${label} backlinks…`,
      startedTier3: (label) =>
        `${label} started in background — sources come from already published Tier-2 posts in the campaign. Refresh the page in a few minutes.`,
      startedBulk: (label, n) =>
        `${label} started in background for ${n} satellites — refresh the page in a few minutes.`,
      errorPrefix: (label) => `${label} error: `,
      tryLater: "Try again later",
      onlyAdmin: "admin only",
      later: "later",
      buttons: {
        bothTitle: "Run Tier-2 and Tier-3 sequentially",
        bothTitleDisabled: "Publish articles first",
        tier2Title: "Run Tier-2 only (no Tier-3)",
        tier3Title:
          "Run Tier-3 only (sources are already-published Tier-2 posts without a Tier-3 backlink)",
      },
      viewer: {
        button: "T2/T3 list",
        buttonTitle:
          "View every Tier-2 and Tier-3 post linked to this campaign — click any URL to verify the live page.",
        title: "Tier-2 / Tier-3 posts",
        intro:
          "Click any URL to open the actual published post on the third-party platform in a new tab.",
        filter: "Filter:",
        all: "All",
        publishedOnly: "Published",
        failedOnly: "Failed",
        refresh: "Refresh",
        tier2Header: "Tier-2",
        tier3Header: "Tier-3",
        empty:
          "Nothing here yet. Run T2/T3 from the campaign card to populate.",
        openLink: "Open in new tab",
        noUrl: "no public URL",
        anchor: "anchor",
        sat: "satellite",
        target: "target",
        source: "source",
      },
      replay: {
        running: "Replaying quota-blocked articles…",
        error: "Replay error: ",
        btnTitle: "Re-send articles stuck due to CF KV limits",
      },
      cleanup: {
        summaryHeader: "Found for deletion:",
        tier2Failed: (n) => `• Tier-2 failed: ${n}`,
        tier3Failed: (n) => `• Tier-3 failed: ${n}`,
        removedAdapters: (n, detail) =>
          `• Tier-2 from removed adapters: ${n}${detail ? ` (${detail})` : ""}`,
        staleFlags: (n) => `• Stale CF KV flags: ${n}`,
        orphansHeader: "Orphan records (report only, not deleted):",
        articlesNoCampaign: (n) => `• Articles without a campaign: ${n}`,
        articlesNoSatellite: (n) => `• Articles without a satellite: ${n}`,
        tier2NoSatellite: (n) => `• Tier-2 without a satellite: ${n}`,
        confirm: "Delete and clear flags? (cancel = do nothing)",
        cancelled: "Cleanup cancelled",
        success: (c) =>
          `Cleanup done: -${c.t2 || 0} t2, ` +
          `-${c.t3 || 0} t3, ` +
          `-${c.adapters || 0} removed adapters, ` +
          `-${c.staleFlags || 0} stale flags, ` +
          `+${c.backfill || 0} backfilled, ` +
          `~${c.counters || 0} counters`,
        error: "Cleanup error: ",
        btnTitle:
          "Delete failed tier-2/3 rows, clear stale quota flags, add campaign_id where possible. Shows numbers first, then asks for confirmation.",
      },
      sync: {
        panelTitle: "Sync platforms — reconcile audit with live URLs",
        modeLabel: "Mode",
        modeOptionPlatforms: "By platforms (adapter names, comma-separated)",
        modeOptionWhitelist: "By whitelist (paste valid URLs)",
        behaviorLabel: "Apply behavior",
        behaviorSoft: "Mark invalid (reversible, recommended)",
        behaviorHard: "Hard delete (IRREVERSIBLE)",
        platformsLabel: "Platforms (comma-separated)",
        platformsHelp:
          "Adapter names as in the `platform` field of audit rows. " +
          "Active: telegraph, devto, tumblr, wp_bridge, justpaste, writeas, pastebin, " +
          "telegraph_t3, archive_org, archive_today, graph_org, rentry, dpaste_com. " +
          "Removed/banned (to clean up old rows): wordpress, github_gist, hashnode, medium.",
        whitelistLabel: "Whitelist URLs (one per line)",
        whitelistHelp:
          "Rows in pbn_tier2/3_posts whose `public_url` is NOT in this list will be " +
          "marked/deleted. Comparison is case-sensitive; trailing slash is stripped. " +
          "Empty lines and lines starting with `#` are ignored.",
        platformsRequired: "Specify at least one platform (e.g. wordpress)",
        urlsRequired:
          "Paste a list of URLs (one per line) — empty input is not allowed",
        dryRunBtn: "Dry-run (preview numbers)",
        dryRunInfo: (n) =>
          `Dry-run: ${n} rows match the filter. Review the breakdown below and click Apply.`,
        dryRunError: "Dry-run error: ",
        dryRunResultHeader: "Dry-run result:",
        matchingRows: "matching rows",
        verbHard: "PERMANENTLY DELETE",
        verbSoft: "mark invalid",
        modeHard: "IRREVERSIBLE",
        modeSoft: "reversible — status='invalid'",
        confirm: (verb, n, mode) => `${verb} ${n} rows? (this is ${mode})`,
        cancelled: "Sync cancelled",
        success: (n, mode) =>
          `Sync done: ${n} rows ${mode}. Counters will recompute on refresh.`,
        successDeleted: "deleted",
        successInvalid: "marked invalid",
        error: "Sync error: ",
        btnTitle:
          "Reconcile pbn_tier2/3_posts with actual URLs on platforms. Two modes: by platform name (e.g. wordpress) or by a list of valid URLs.",
      },
    },

    brandIdentity: {
      buttonTitle: "Set brand identity for every satellite in this campaign",
      title: "Brand identity",
      description:
        "Sets the same Organization JSON-LD (name, logo, official links) on every satellite in this campaign, so search engines merge them into one recognised entity instead of treating each domain as anonymous.",
      warningTitle: "Opposite of anti-footprint: read before using",
      warningBody:
        "This writes IDENTICAL structured data (name, logo, links) into every satellite in this campaign — a direct, machine-readable signal that they are the same publisher. Everything else in this network (anchors, authors, homepages) is deliberately kept unique to avoid exactly this kind of pattern. Only use this on satellites you WANT search engines to recognize as one visible brand — never as a routine action across a network meant to look independent.",
      confirmLabel:
        "I understand this links every satellite in this campaign together via public structured data, and I want that.",
      name: "Name",
      legalName: "Legal name",
      logoUrl: "Logo URL",
      sameAs: "Official links (sameAs) — one per line",
      sameAsHint:
        "Social/profile URLs that identify the same real-world entity — feeds Google's entity graph.",
      contactEmail: "Contact email",
      contactUrl: "Contact page URL",
      foundingDate: "Founding date",
      descriptionLabel: "Description",
      appliesTo: "Applies to all {n} satellite(s) in this campaign.",
      cancel: "Cancel",
      save: "Apply to campaign",
      saved: "Brand identity applied to {n} satellite(s)",
      saveError: "Could not save brand identity",
    },
  },

  // Audit
  audit: {
    title: "SEO Audit",
    subtitle: "Technical analysis of your sites",
    run: "Run Audit",
    running: "Running...",
    score: "Score",
    issues: "Issues",
    foundIssues: (n) => `Found issues (${n})`,
    lastAudit: "Last Audit",
    noSites: "No sites",
    noSitesDesc: "Add a site first",
    noAudit: "No audit data",
    noAuditDesc: "Run an audit to see results",
    noAuditYet: "No audit yet",
    runFirstAudit: "Run the first audit for the selected site",
    robots: "Robots",
    notSpecified: "Not specified",
    withoutAlt: "Without alt",
    images: "images",
    critical: "Critical",
    high: "High",
    medium: "Medium",
    low: "Low",
  },

  // Automation
  automation: {
    title: "Automation",
    subtitle: "Automated tasks and notifications",
    overviewTitle: "Where to start",
    overviewDesc:
      "Automation does 3 things: checks rankings on a schedule, alerts you on Telegram, and publishes articles to your site via webhook. Set them up in order — one at a time.",
    step1Title: "1. Scheduled position checks",
    step1Body:
      "Every N hours the system pulls positions from DataForSEO and appends to history. Requires DataForSEO login/password in Settings → API keys.",
    step2Title: "2. Telegram notifications",
    step2Body:
      "The bot pings you on Telegram when rankings change meaningfully (entering top-10, dropping out of top-100, etc.). You'll need a Bot Token and Chat ID — instructions in the card below.",
    step3Title: "3. Auto-publish articles",
    step3Body:
      "Webhook ships generated articles to your site/CMS. Drop in the endpoint URL (optionally a secret for HMAC signing).",
    statusReady: "Ready",
    statusOff: "Not set up",
    nextRun: "Next automatic check",
    scheduler: "Task Scheduler",
    schedulerDesc: "Automatic position checks on schedule",
    active: "Active",
    paused: "Paused",
    pause: "⏸ Pause",
    resume: "▶ Resume",
    interval: "Check Interval",
    apply: "Apply",
    runNow: "▶ Run Now",
    running: "Running...",
    every1h: "Every hour",
    every3h: "Every 3 hours",
    every6h: "Every 6 hours",
    every12h: "Every 12 hours",
    everyDay: "Once a day",
    webhook: "Webhook — Auto Publishing",
    webhookDesc: "Automatically send generated articles to your site or CMS",
    webhookURL: "Webhook URL",
    webhookHolder: "https://your-site.com/api/publish",
    webhookHint: "Endpoint that receives POST request with JSON article",
    secret: "Secret (optional)",
    secretHolder: "your-webhook-secret",
    secretHint:
      "Signs the request with X-Webhook-Signature header (HMAC SHA256)",
    save: "Save",
    test: "Test",
    telegram: "Telegram Notifications",
    telegramDesc: "Get notified about ranking changes",
    notConfigured: "Not configured",
    botToken: "Bot Token",
    chatId: "Chat ID",
    connect: "Connect Telegram",
    connecting: "Connecting...",
    testTelegram: "Test Notification",
    botTokenHelp: "How to get bot token:",
    chatIdHelp: "How to get Chat ID:",
    step1: "Message @BotFather on Telegram",
    step2: "Send /newbot and follow instructions",
    step3: "Copy the received token",
    step4: "Message @userinfobot on Telegram",
    step5: "Copy your numeric ID",
    connected: "Connected",
    testSent: "Test message sent",
    sendError: "Sending error",
    enterWebhookUrl: "Enter Webhook URL",
    webhookResponse: (n) => `Webhook responded: ${n}`,
    webhookConnectErr: "Could not connect to webhook",
    webhookReady: "Webhook configured and ready",
    notifyAbout: "You will receive notifications about:",
    notify1: "Position changes by 5+ points",
    notify2: "Entering TOP-10",
    notify3: "Exiting TOP-100",
    autoActions: "Automated Actions",
    posChecksTitle: "Position Checks",
    posChecksDesc: (n) =>
      `Every ${n} hour(s) the system checks keyword positions via DataForSEO`,
    autoIndexTitle: "Auto-indexing",
    autoIndexDesc:
      "When an article is generated, the URL is automatically submitted to Yandex, Bing and Google",
    notifTitle: "Notifications",
    notifDesc:
      "Telegram bot will instantly notify you about important ranking changes",
    payloadFormat: "Payload format (JSON):",
    compatible: "Compatible with:",
    compatibleList:
      "WordPress REST API, Ghost CMS, Strapi, any custom backend",
    publishPbn: "Publish PBN articles",
    selectCampaign: "Select PBN campaign",
    publishPbnBtn: "Publish all draft PBN articles",
  },
  promotion: {
    title: "Promotion Tools",
    subtitle: "Everything you need to rank in search engines",
    noSites: "No sites",
    noSitesDesc: "Add a site first",
    selectSite: "Select site",
    competitors: "Competitors",
    plan: "Promotion Plan",
    linkBuilding: "Link Building",
    indexation: "Indexation",
    comp: {
      cardTitle: "Competitor Analysis",
      cardDesc: "Find out what top-10 sites do for your query",
      keyword: "Keyword",
      keyHolder: "e.g. buy laptop online",
      analyze: "Analyze",
      resultTitle: "Analysis Result",
      difficulty: "Keyword difficulty",
      wordCount: "Recommended article length",
      words: "words",
      lsi: "LSI keywords:",
      strategy: "Recommended strategy:",
      empty: 'Enter a keyword and click "Analyze"',
    },
    planCard: {
      desc: "AI will create a detailed plan for 3 months",
      keysLabel: "Target keywords (one per line)",
      keysHolder: "buy laptop\nlaptop for work\nbest laptop 2026",
      budgetLabel: "Budget",
      budgetLow: "Low (only time)",
      budgetMed: "Medium (up to $500/mo)",
      budgetHigh: "High ($500+/mo)",
      create: "Create Plan",
      copy: "Copy",
      empty: "Enter keywords to create a plan",
    },
    backlinks: {
      cardTitle: "Create link building task",
      cardDesc: "AI will give recommendations for getting backlinks",
      urlLabel: "URL page for promotion",
      urlHolder: "https://yoursite.com/article",
      anchorLabel: "Anchor text",
      anchorHolder: "buy laptop",
      getBtn: "Get recommendations",
      resultTitle: "Link building recommendations",
      empty: "Fill in the form to get recommendations",
    },
    index: {
      cardTitle: "URL Auto-Indexation",
      cardDesc: "Submit URLs to all search engines in one click",
      urlsLabel: "URLs (one per line)",
      allBtn: "All at once",
      note: "IndexNow: Yandex, Bing • Google: requires setup",
      googleLabel: "Google Indexing API",
      instruction: "Step-by-step guide",
      credHolder:
        "Paste Service Account JSON key from Google Cloud Console...",
      saveCreds: "Save Google credentials",
      resultTitle: "Result",
      submitted: (n) => `Submitted: ${n} URLs`,
      setupTitle: "Setup Google Indexing API:",
      credsSaved: "✓ Google credentials saved",
      empty: 'Enter URLs and click "All at once"',
      emptySub: "or configure Google Indexing API",
      addAccount: "○ Add Google Service Account",
      googleSent: (n) => `✓ ${n} URL sent`,
      important: "Important:",
      indexSatellites: "Index all PBN satellites",
    },
    toast: {
      loadErr: "Loading error",
      enterKw: "Enter a keyword",
      analyzed: "Analysis complete",
      analysisErr: "Analysis error",
      enterKws: "Enter keywords",
      planCreated: "Plan created",
      planErr: "Error creating plan",
      fillFields: "Fill in all fields",
      taskCreated: "Task created",
      taskErr: "Error creating task",
      enterUrl: "Enter a URL",
      sitemapDone: "Sitemap created",
      sitemapErr: "Error creating sitemap",
      indexNowDone: "URLs submitted for indexation",
      indexAllDone: "URLs submitted to all search engines",
      submitErr: "Submission error",
      enterJson: "Paste JSON key",
      credsSaved: "Google credentials saved",
      instrErr: "Error loading instructions",
      copied: "Copied",
      copyErr: "Copy error",
    },
  },

  // Reports
  reports: {
    title: "Reports",
    subtitle: "SEO reports and analytics",
    generate: "Generate Report",
    download: "Download",
    noReports: "No reports yet",
    noReportsDesc: "Generate your first SEO report",
    site: "Site",
    date: "Date",
    type: "Type",
    reportLabel: "Report",
    reportFor: "Report:",
    seoScore: "SEO score",
    audits: "Audits",
    keywordsLabel: "Keywords",
    reportDate: "Report date",
    mainIssues: "Main issues",
    recommendations: "Recommendations",
    occurrences: (n) => `${n} ×`,
    scoreHistory: "Score history",
    pointsTitle: (n) => `${n} points`,
  },

  // NotFound
  notFound: {
    title: "404",
    text: "Page not found",
    cta: "Go to Dashboard",
  },

  // Score ring buckets
  score: {
    excellent: "Excellent",
    good: "Good",
    average: "Average",
    poor: "Poor",
  },

  // Onboarding wizard (shown on Dashboard when 0 sites)
  onboarding: {
    kicker: "// GET STARTED · 3 STEPS",
    welcome: "Welcome to",
    welcomeProduct: "CBN",
    lead: "Track rankings, audit sites, generate content — automated.",
    step1Label: "Add your site",
    step1Desc: "Connect a domain to start indexing keywords and audits.",
    step2Label: "Run first audit",
    step2Desc: "See SEO score, robots, sitemap and per-page issues.",
    step3Label: "Track keywords",
    step3Desc: "Real positions via DataForSEO, AI articles via DeepSeek.",
    primaryCta: "+ Add your first site",
    secondaryCta: "Skip — explore the dashboard",
  },

  // Settings
  settings: {
    title: "API keys",
    subtitle: "External service credentials",
    save: "Save changes",
    saving: "Saving...",
    saved: "Saved",
    addonTitle: "Addon connection",
    addonConnected: "Connected",
    addonDisconnected: "Not connected",
    addonConnect: "Connect",
    addonDisconnect: "Disconnect",
  },

  // Content
  content: {
    title: "AI Content",
    subtitle: "Generate SEO content with AI",
    generate: "Generate",
    generating: "Generating...",
    copy: "Copy",
    copied: "Copied!",
    selectSite: "Select site",
    topic: "Topic / keyword",
    topicPlaceholder: "e.g. buy iPhone 15",
    language: "Language",
    noSites: "No sites",
    noSitesDesc: "Add a site on the 'Sites' page first",
    site: "Site",
    contentType: "Content type",
    generator: "Generator",
    result: "Result",
    history: "History",
    aiWorking: "AI is generating content…",
    emptyHint: "Enter a topic and press 'Generate'",
    suggestions: "Variants:",
    topicLabel: "Topic:",
    emptyHistory: "History is empty",
    successGen: "Content generated",
    errors: {
      loadSites: "Failed to load sites",
      emptyForm: "Pick a site and enter a topic",
      generate: "Generation error: ",
      copy: "Copy failed",
      retryLater: "try again later",
    },
    types: {
      meta_title: { label: "Meta Title", description: "SEO page title (50–60 characters)" },
      meta_description: { label: "Meta Description", description: "Search-result description (120–155 characters)" },
      h1: { label: "H1 heading", description: "Main page heading" },
      article_outline: { label: "Article outline", description: "SEO article plan with headings" },
      keywords: { label: "Keywords", description: "Relevant search queries" },
    },
  },

  // GoogleSetup
  googleSetup: {
    title: "Google Indexing Setup",
    subtitle: "Connect Google Indexing API step by step",
    back: "Back to promotion",
    stepN: "Step",
    next: "Next",
    prev: "Back",
    done: "Done — go to indexing",
    copied: "Copied",
    copyError: "Copy failed",
    warningLabel: "Important:",
    warningBody:
      "Google Indexing API is officially supported only for pages with JobPosting or BroadcastEvent schema. Many sites use it for regular pages successfully nonetheless.",
    step5ExampleLabel: "Service Account email example:",
    quickLinks: "Useful links",
    links: {
      cloudConsole: "Google Cloud Console",
      searchConsole: "Google Search Console",
      docs: "Google docs",
    },
    steps: [
      {
        title: "Create a Google Cloud project",
        description: "Open console.cloud.google.com and sign in with a Google account.",
        details: [
          "Click the project dropdown at the top.",
          "Choose 'New Project'.",
          "Name it, e.g. 'SEO Indexing'.",
          "Click 'Create'.",
        ],
        linkText: "Open Google Cloud Console",
      },
      {
        title: "Enable the Indexing API",
        description: "Activate the API used for indexing.",
        details: [
          "In the left menu choose 'APIs & Services' → 'Library'.",
          "Search 'Web Search Indexing API'.",
          "Click the result.",
          "Click 'Enable'.",
        ],
        linkText: "Open Indexing API",
      },
      {
        title: "Create a Service Account",
        description: "Provision a service account for API access.",
        details: [
          "Go to 'APIs & Services' → 'Credentials'.",
          "Click 'Create Credentials' → 'Service Account'.",
          "Enter a name, e.g. 'seo-indexer'.",
          "Click 'Create and Continue'.",
          "Role can be skipped → 'Continue' → 'Done'.",
        ],
        linkText: "Create Service Account",
      },
      {
        title: "Download the JSON key",
        description: "Get the credentials file.",
        details: [
          "On the Credentials page click the new Service Account.",
          "Open the 'Keys' tab.",
          "Click 'Add Key' → 'Create new key'.",
          "Pick 'JSON' → 'Create'.",
          "The file downloads automatically — keep it safe!",
        ],
      },
      {
        title: "Add to Google Search Console",
        description: "Grant the Service Account access to your site.",
        details: [
          "Open the downloaded JSON and copy 'client_email'.",
          "Open Google Search Console.",
          "Pick your site → Settings → Users and permissions.",
          "Click 'Add user'.",
          "Paste the Service Account email.",
          "Pick role 'Owner'.",
          "Click 'Add'.",
        ],
        linkText: "Open Search Console",
      },
      {
        title: "Upload the JSON to xpnsr SEO",
        description: "Final step — add the key to the platform.",
        details: [
          "Open the downloaded JSON in a text editor.",
          "Copy the full file contents.",
          "In xpnsr SEO: Promotion → Indexing.",
          "Paste the JSON into the 'Google Indexing API' field.",
          "Click 'Save Google credentials'.",
        ],
      },
    ],
  },

  // Common
  common: {
    bulkSelectAll: "Select all",
    bulkClear: "Clear selection",
    bulkDeleteSelected: "Delete selected",
    bulkDeleteAll: "Delete all",
    bulkConfirmSelected: (n) => `Delete ${n} selected item(s)? This cannot be undone.`,
    bulkConfirmAll: (n) => `Delete ALL ${n} item(s)? This cannot be undone.`,
    bulkDeleted: (n) => `Deleted: ${n}`,
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    filter: "Filter",
    all: "All",
    yes: "Yes",
    no: "No",
    error: "Error",
    success: "Success",
    noData: "No data",
    refresh: "Refresh",
    close: "Close",
    select: "Select",
    language: "Language",
    selectSite: "Select site",
    fillFields: "Please fill in all fields",
    tryAgain: "Try again later",
    loadError: "Loading error",
    copied: "Copied",
    copyError: "Failed to copy",
    copy: "Copy",
    done: "Done",
    save: "Save",
  },

  // Admin panel
  admin: {
    title: "Admin",
    tabUsers: "Users",
    tabSettings: "Settings",
    usersHeader: "Users",
    addUser: "Add user",
    createUser: "Create user",
    editUser: "Edit user",
    resetPassword: "Reset password",
    impersonate: "Impersonate",
    email: "Email",
    password: "Password",
    newPassword: "New password",
    passwordAutogen: "Leave empty to auto-generate",
    passwordHint: "At least 8 characters. Will be shown once.",
    role: "Role",
    status: "Status",
    created: "Created",
    lastLogin: "Last login",
    actions: "Actions",
    you: "you",
    inviteSent: "invite pending",
    sendInvite: "Send invite link instead",
    sendInviteDesc: "User picks their own password via a one-time link.",
    inviteLink: "Invite link",
    create: "Create",
    reset: "Reset",
    forceChange: "Force change on next login",
    savedOnce: "Copy these credentials now — they will not be shown again.",
    copied: "Copied to clipboard",
    copyFailed: "Copy failed",
    userCreated: "User created",
    userUpdated: "User updated",
    userDeleted: "User deleted",
    passwordReset: "Password reset",
    settingsSaved: "Settings saved",
    impersonateSuccess: (email) => `Now logged in as ${email}`,
    confirmDelete: (email) => `Delete user ${email}?`,
    confirmDeleteDesc: "This account will be removed immediately.",
    cascadeTitle: "Wipe tenant data too?",
    cascadeDesc: "Also delete every site, keyword, rank history, and article owned by this user. This cannot be undone.",
    cascadeYes: "Yes, wipe everything",
    cascadeNo: "No, keep their data",
    confirmImpersonate: (email) => `Impersonate ${email}?`,
    confirmImpersonateDesc: "You will be logged out of your admin session and signed in as the target user.",
    resetPasswordFor: (email) => `Reset password for ${email}`,
    searchPlaceholder: "Search by email...",
    allRoles: "All roles",
    allStatuses: "All statuses",
    empty: "No users",
    emptyDesc: "Adjust filters or create a user to get started.",
    notAllowed: "Admin only",
    notAllowedDesc: "You do not have permission to view this page.",
    selfEmailLocked: "You can't change your own email here.",
    selfRoleLocked: "You can't demote yourself.",
    selfStatusLocked: "You can't disable yourself.",
    roles: { admin: "Admin", user: "User" },
    statuses: { active: "Active", disabled: "Disabled" },
    settingsTitle: "Platform settings",
    openRegistration: "Open registration",
    openRegistrationDesc: "Allow anyone with the signup link to create an account.",
    defaultRole: "Default role",
    defaultRoleDesc: "Role assigned to newly self-registered users.",
    minPasswordLen: "Minimum password length",
    minPasswordLenDesc: "Applies to new users and admin password resets.",
    errors: {
      emailRequired: "Email is required",
      loadFailed: "Could not load users",
      createFailed: "Could not create user",
      updateFailed: "Could not update user",
      deleteFailed: "Could not delete user",
      resetFailed: "Could not reset password",
      impersonateFailed: "Could not impersonate user",
      saveFailed: "Could not save settings",
    },
    impersonateBanner: (email) =>
      `Signed in as ${email} (impersonating). Return to admin.`,
    impersonateBannerReturn: "Return to admin",
    impersonateReturned: "Switched back to admin",
    impersonateReturnFailed: "Could not return to admin",
  },

  acceptInvite: {
    title: "Set your password",
    sub: "Pick a password to activate your account.",
    emailLabel: "Account",
    passwordLabel: "Password",
    passwordHolder: "••••••••",
    confirmLabel: "Confirm password",
    minHint: (n) => `min ${n} characters`,
    mismatch: "Passwords do not match",
    submit: "Activate account",
    submitting: "Activating…",
    success: "Account activated",
    loading: "Loading invite…",
    invalid: "This invite link is invalid or has expired.",
    invalidGoLogin: "Go to login",
    backToLogin: "Back to login",
    expiresAt: (when) => `Expires ${when}`,
  },

  forceChangePassword: {
    title: "Change your password",
    sub: "An administrator reset your password — pick a new one to continue.",
    current: "Temporary password",
    currentHolder: "Paste the temporary password",
    nextLabel: "New password",
    confirmLabel: "Confirm new password",
    minHint: (n) => `min ${n} characters`,
    mismatch: "Passwords do not match",
    submit: "Change password",
    submitting: "Changing…",
    success: "Password changed",
    signOut: "Sign out",
    error: "Could not change password",
  },
};
